var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('BaseChart',_vm._b({key:_vm.rerenderKey},'BaseChart',{..._vm.chartData},false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }